import React, { createContext, useContext, useState, useCallback } from 'react';
import ptBR from './local/pt-BR/home';
import en from './local/en/home';
import de from './local/de/home';

type Dict = Record<string, string>;

const resources: Record<string, Dict> = {
  'pt-BR': ptBR as Dict,
  en: en as Dict,
  de: de as Dict,
};

interface I18nContextType {
  t: (key: string) => string;
  i18n: {
    language: string;
    changeLanguage: (lang: string) => void;
  };
  ready: boolean;
}

const I18nContext = createContext<I18nContextType>({
  t: (key: string) => key,
  i18n: { language: 'pt-BR', changeLanguage: () => {} },
  ready: true,
});

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLang] = useState<string>('pt-BR');

  const t = useCallback(
    (key: string) => {
      const dict = resources[lang] || resources['pt-BR'];
      return dict[key] ?? resources['pt-BR'][key] ?? key;
    },
    [lang],
  );

  const changeLanguage = useCallback((newLang: string) => {
    setLang(resources[newLang] ? newLang : 'pt-BR');
  }, []);

  const value: I18nContextType = {
    t,
    i18n: { language: lang, changeLanguage },
    ready: true,
  };

  return React.createElement(I18nContext.Provider, { value }, children);
}

export function useTranslation(_ns?: string) {
  return useContext(I18nContext);
}